import React, { useEffect, useState, useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const APPARELS = [
  {id:"tshirt",name:"T-Shirts"},{id:"premium_tshirt",name:"Premium Tees"},{id:"hoodie",name:"Hoodies"},
  {id:"crewneck",name:"Crewnecks"},{id:"longsleeve",name:"Long Sleeves"},{id:"tank",name:"Tanks"},
  {id:"sweatpants",name:"Sweatpants"},{id:"joggers",name:"Joggers"},{id:"shorts",name:"Shorts"},
  {id:"hat",name:"Hats"},{id:"totebag",name:"Tote Bags"},
];
const COLORS = ["Black","White","Royal Blue","Navy","Heather Grey","Sport Red"];

// Exact official collection display names — never shorten/rename.
const COLLECTION_LABELS = {
  "the-doodles-official-collection": "The Doodles Official Collection",
  "military-official-collection": "Military Official Collection",
  "one-united-official-collection": "One United Official Collection",
  "childrens-official-collection": "Children\u2019s Official Collection",
  "seniors-collection": "Seniors Collection",
  "the-encore-official-collection": "The Encore Official Collection",
  "graphics-official-collection": "Graphics Official Collection",
  "sports-official-collection": "Sports Official Collection",
  "spine-official-collection": "Spine Official Collection",
};

export default function CollectionPage() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [apparel, setApparel] = useState(params.get("apparel") || "");
  const [color, setColor] = useState("");
  const [sort, setSort] = useState("new");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const r = await api.get("/products", { params: { collection: slug, apparel: apparel || undefined, color: color || undefined, sort, limit: 60 } });
    setProducts(r.data.items);
    setLoading(false);
  }, [slug, apparel, color, sort]);
  useEffect(() => { load(); }, [load]);

  const title = COLLECTION_LABELS[slug] || slug.replace(/-/g," ").replace(/\b\w/g, l => l.toUpperCase());
  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-8 py-12" data-testid={`collection-${slug}`}>
      <div className="mb-8">
        <div className="text-xs tracking-[0.3em] uppercase text-neutral-500 mb-2">Collection</div>
        <h1 className="font-display text-6xl text-[color:var(--hb-navy)]">{title}</h1>
      </div>

      <div className="flex flex-wrap gap-4 mb-8 items-center border-y border-neutral-200 py-4">
        <select value={apparel} onChange={e=>setApparel(e.target.value)} className="text-sm border border-neutral-300 px-3 py-2 bg-white" data-testid="filter-apparel">
          <option value="">All Apparel</option>
          {APPARELS.map(a=><option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
        <select value={color} onChange={e=>setColor(e.target.value)} className="text-sm border border-neutral-300 px-3 py-2 bg-white" data-testid="filter-color">
          <option value="">All Colors</option>
          {COLORS.map(c=><option key={c} value={c}>{c}</option>)}
        </select>
        <select value={sort} onChange={e=>setSort(e.target.value)} className="text-sm border border-neutral-300 px-3 py-2 bg-white ml-auto" data-testid="filter-sort">
          <option value="new">Newest</option>
          <option value="best">Best Selling</option>
        </select>
        <div className="text-xs text-neutral-500">{products.length} results</div>
      </div>

      {loading ? (
        <div className="py-20 text-center text-neutral-500 text-sm">Loading…</div>
      ) : products.length === 0 ? (
        <div className="py-20 text-center text-neutral-500">No products yet in this collection.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-testid="collection-grid">
          {products.map(p => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
}
